
const initialState = { etiquetas: [] }

export function reducerDropdown (state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_ETIQUETAS_DROPDOWN':
      return { ...state, etiquetas: action.etiquetas }
    case 'UPDATE_CEREAL_DROPDOWN_ETIQUETA':
      return { ...state, cereal: action.cereal }
    case 'UPDATE_CEREAL_VARIEDAD_DROPDOWN_ETIQUETA':
      return { ...state, cerealVariedad: action.cerealVariedad }

    default:
      return state
  }
}
